// tslint:disable:max-line-length

import React from 'react';

export const ActionShow = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path
        d="M8.063 0c-5.063 0-8.063 6-8.063 6s2.999 6 8.063 6c4.938 0 7.938-6 7.938-6s-2.999-6-7.938-6zm-.063 2c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zm0 2c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2c0-.204-.037-.408-.094-.594-.159.343-.504.594-.906.594-.552 0-1-.448-1-1 0-.403.251-.748.594-.906-.186-.057-.389-.094-.594-.094z"
        transform="translate(0 2)"
      />
    </svg>
  );
};
